import React, { Component } from "react";

class LoadingData extends Component {
    render() {
        return  <div id="loading-bg">
                    <div className="loading">
                    	<div className="effect-1 effects"></div>
                    	<div className="effect-2 effects"></div>
                    	<div className="effect-3 effects"></div>
              	    </div>
                </div>;
    }
}

export default LoadingData;



// WEBPACK FOOTER //
// ./src/components/utilities/LoadingData.js